import{useContext as r}from"react";import{InternalAuthContext as t}from"./InternalAuthProvider.js";var o=function(){return r(t)};export{o as default};
//# sourceMappingURL=useInternalAuth.js.map
